import { createAction } from 'redux-actions';

export const setSourceStatementLoaded = createAction(
  'SET_IS_SOURCE_STATEMENT_LOADED',
);
